import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search-result-details-pane iodine-no-scroll-y full-height text-center flex-grow-1 flex-shrink-0" }

import SearchResultDetailsTitle from 'components/search/SearchResultDetailsTitle.vue';
import SearchResultDetailsToolbar from 'components/search/SearchResultDetailsToolbar.vue';
import SearchResultDetailsContent from 'components/search/SearchResultDetailsContent.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResultDetailsPane',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SearchResultDetailsTitle, { "book-description": 'ICD-10-CM Diagnosis Tabular (2024)' }, null, 8, ["book-description"]),
    _createVNode(SearchResultDetailsToolbar),
    _createVNode(SearchResultDetailsContent)
  ]))
}
}

})